import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getRestaurantDetails } from "../actions/restaurantActions";
import SwitchOnAndOff from "../components/SwitchOnAndOff";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import styled from "styled-components";
import SubMenu from "../components/SubMenu";
import {
  fetchRestaurantDetails,
  updateRestaurant,
  createRestaurant,
} from "../actions/restaurantActions";
import ScrollInputOptions from "../components/ScrollInputOptions";
import Separator from "../components/Separator";
import { Row, Col } from "react-bootstrap";
import moment from "moment-timezone";
import DropDownButton from "../components/DropDownButton";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  useJsApiLoader,
} from "@react-google-maps/api";
import "react-phone-input-2/lib/style.css"; // Default CSS for react-phone-input-2
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"; // Bootstrap CSS for additional styling
import { PhoneNumber } from "libphonenumber-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePhoneFlip } from "@fortawesome/free-solid-svg-icons";
import { getDialCode, getCountryCode } from "../components/CountryCode";
/* global google */
import { isValidNumber } from "libphonenumber-js";
import {
  ContainerBox,
  Header,
  Body,
  OrangeButton,
  Title,
  Container,
  CardHeader,
  CardHeaderTitle,
  StyledLabel,
  ModernButton,
} from "../components/DefaultImports";
import PhoneField from "../components/PhoneField";

const BOTTOM_PADDING = 20;

const StyledInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 18px;
  font-size: 16px;
  border: 1px solid ${(props) => (props.invalid ? "#dc3545" : "#ddd")};
  border-radius: 10px;
  background-color: #fafafa;
  transition: all 0.2s ease;
  &:focus {
    border-color: ${(props) => (props.invalid ? "#dc3545" : "#de8c3a")};
    background-color: #fff;
    box-shadow: ${(props) =>
      props.invalid
        ? "0 0 0 4px rgba(220, 53, 69, 0.15)"
        : "0 0 0 4px rgba(222, 140, 58, 0.15)"};
    outline: none;
  }
  &::placeholder {
    color: #aaa;
  }
`;

const PageScroll = styled.div`
  height: ${(props) => props.height || 400}px;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;

  /* Neutralize Bootstrap .row negative margins inside the scroller */
  & .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  /* Allow columns to shrink; avoids flex overflow on narrow screens */
  & .col,
  & [class*="col-"] {
    padding-left: 12px;
    padding-right: 12px;
    min-width: 0;
  }

  /* Thin, subtle scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`;

/* ===================== your existing styled ===================== */

const Form = styled.form`
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

const InputOverlay = styled.input`
  position: absolute;
  top: 33px;
  font-size: 16px;
  left: 105px;
  height: 36px;
  border: none;
  border-radius: 0 3px 0 0;
  background: none;
  outline: none;
  background-color: none;
  padding-bottom: 4px;
`;

const MapContainer = styled.div`
  width: 100%;
  max-width: 100%; /* prevent map UI from pushing width */
  overflow: hidden; /* safety against child overflow */
  height: 100%;
  min-height: 400px;

  @media (min-width: 768px) {
    height: 380px; // Pleasant fixed height on desktop
  }

  @media (max-width: 768px) {
    min-height: 250px;
  }

  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

/* ===================== utils ===================== */

const getTimezone = () => {
  if (window.Intl && window.Intl.DateTimeFormat) {
    const options = new window.Intl.DateTimeFormat().resolvedOptions();
    return options && options.timeZone ? options.timeZone : "";
  }
  return "";
};

function RestaurantSettingsUpdate({
  creating_restaurant = "no",
  handleNextStep = false,
  restaurantCreated = false,
  setCreateRestaurantToFalse = false,
  steps = false,
}) {
  const dispatch = useDispatch();
  const params = useParams();
  const [restaurantId, setRestaurantId] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("ok_status");

  const [restaurantName, setRestaurantName] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState(false);
  const [locality, setLocality] = useState("");

  const [longitudeField, setLongitudeField] = useState(0.0);
  const [latitudeField, setLatitudeField] = useState(0.0);
  const [viewDistance, setViewDistance] = useState(18);

  const [numberOfChairs, setNumberOfChairs] = useState(0);
  const [numberOfBabyChairs, setNumberOfBabyChairs] = useState("");
  const [limitPeopleReservation, setLimitPeopleReservation] = useState("");
  const [limitBabyChairsReservation, setLimitBabyChairsReservation] =
    useState("");
  const [autoAcceptLimit, setAutoAcceptLimit] = useState("");
  const [eachTime, setEachTime] = useState("00:15");
  const [acceptPeoplePerEachTime, setAcceptPeoplePerEachTime] = useState("");
  const [timezone, setTimezone] = useState(getTimezone());
  const timezones = moment.tz.names();
  const [autoAcceptTimeLimit, setAutoAcceptTimeLimit] = useState("");
  const [messageReminderTime, setMessageReminderTime] = useState("");
  const [autoSetTables, setAutoSetTables] = useState(null);
  const [timeToCancelledWarning, setTimeToCancelledWarning] = useState("");

  const [countryCode, setCountryCode] = useState("pt");
  const [countryCodeNumber, setCountryCodeNumber] = useState("351");
  const [phoneWithoutCountryCode, setPhoneWithoutCountryCode] = useState("");
  const [restaurant_description, setRestaurant_description] = useState("");
  const [reconfirmation_duration, setReconfirmation_duration] = useState("");
  const [reconfirmation_time_before_date, setReconfirmation_time_before_date] =
    useState("");

  const [restaurant_params, setRestaurant_params] = useState({});

  const { isLoaded: isGoogleLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyA7wQgzKIx0-y6j3pfy341jX6LmYq5_Sc4",
  });

  const [marker, setMarker] = useState(false);
  const [allowGeocode, setAllowGeocode] = useState(false);
  const [mapCenter, setMapCenter] = useState({ lat: 0, lng: 0 });
  const [isPhoneValid, setIsPhoneValid] = useState(true);

  // Compute available height for the internal scroll area (like Managers page)
  const pageRef = useRef(null);
  const [pageHeight, setPageHeight] = useState(0);
  const [invalidFields, setInvalidFields] = useState(new Set());

  useLayoutEffect(() => {
    if (!pageRef.current) return;

    const updateHeight = () => {
      if (!pageRef.current) return;
      const top = pageRef.current.getBoundingClientRect().top;
      const height = window.innerHeight - top - BOTTOM_PADDING;
      setPageHeight(Math.max(0, height));
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    window.addEventListener("orientationchange", updateHeight);

    const ro = new ResizeObserver(() => updateHeight());
    ro.observe(document.body);

    const raf = requestAnimationFrame(updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      window.removeEventListener("orientationchange", updateHeight);
      ro.disconnect();
      cancelAnimationFrame(raf);
    };
  }, []);

  // Set the flag to true after 3 seconds (avoid geocode spam while typing)
  useEffect(() => {
    const timer = setTimeout(() => {
      setAllowGeocode(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  // Geocode once address/locality/postalCode are provided and Google is loaded
  useEffect(() => {
    if (allowGeocode && isGoogleLoaded) {
      const fullAddressQuery = [address, locality, postalCode]
        .filter(Boolean)
        .join(", ");

      if (!fullAddressQuery) return;

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: fullAddressQuery }, (results, status) => {
        if (status === "OK" && results.length > 0) {
          const location = results[0].geometry.location;
          setLatitudeField(location.lat());
          setLongitudeField(location.lng());
          setMarker({
            lat: location.lat(),
            lng: location.lng(),
          });
        } else {
          console.error("Geocode failed:", status);
        }
      });
    }
  }, [address, locality, postalCode, isGoogleLoaded, allowGeocode]);

  const detectCountryCode = () => {
    const userCountryCode = navigator.language.split("-")[1];
    const formattedCountryCode = userCountryCode
      ? userCountryCode.toLowerCase()
      : "us";
    return formattedCountryCode; // Default to 'us' if not detected
  };

  const handleOnZoomChanged = React.useCallback((map) => {
    const zoomLevel = map.getZoom();
    setViewDistance(zoomLevel);
  }, []);

  useEffect(() => {
    if (countryCodeNumber === "") {
      const detectedCountryCode = detectCountryCode();
      setCountryCode(detectedCountryCode);
      setCountryCodeNumber(getDialCode(detectedCountryCode));
    } else {
      setCountryCode(getCountryCode(countryCodeNumber));
    }
  }, [countryCodeNumber, countryCode]);

  const onMapClick = React.useCallback((event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setMarker({ lat, lng });
    setLatitudeField(lat);
    setLongitudeField(lng);
    setMapCenter({ lat, lng }); // keep the map centered on the marker
  }, []);

  const handleOnLoad = (map) => {
    // The google object is available here
    if (isGoogleLoaded) {
      google.maps.event.trigger(map, "resize");
      map.addListener("zoom_changed", () => handleOnZoomChanged(map));
    }
  };

  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants, isLoading, error } = restaurantDetails;

  const generateIntervalOptions = () => {
    const intervalOptions = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 15) {
        // Format hour and minute to two digits
        const hour = i.toString().padStart(2, "0");
        const minute = j.toString().padStart(2, "0");
        const time = `${hour}:${minute}`;

        if (time >= "00:15" && time <= "08:00") {
          intervalOptions.push(time);
        }
      }
    }
    return intervalOptions;
  };

  const generateNumberOptions = () => {
    const numberOptions = [];
    for (let i = 0; i < 100; i++) {
      numberOptions.push(i);
    }
    return numberOptions;
  };

  // Usage:
  const [numberOptions, setNumberOptions] = useState(generateNumberOptions());
  const [intervalOptions, setIntervalOptions] = useState(
    generateIntervalOptions()
  );

  useEffect(() => {
    if (restaurants) {
      setRestaurantId(restaurants.id);
    }
  }, [restaurants]);

  useEffect(() => {
    if (restaurants && restaurants.id) {
      setRestaurantName(restaurants.restaurant_name || "");
      setAddress(restaurants.adress || "");
      setPostalCode(restaurants.postal_code || "");
      setLocality(restaurants.locality || "");
      setLatitudeField(parseFloat(restaurants.latitude) || 0);
      setLongitudeField(parseFloat(restaurants.longitude) || 0);
      setViewDistance(restaurants.view_distance || 18);
      setMarker({
        lat: parseFloat(restaurants.latitude) || 0,
        lng: parseFloat(restaurants.longitude) || 0,
      });
      setMapCenter({
        lat: parseFloat(restaurants.latitude) || 0,
        lng: parseFloat(restaurants.longitude) || 0,
      });
      setNumberOfBabyChairs(restaurants.number_of_babychairs || 0);
      setLimitPeopleReservation(restaurants.limit_people_reservation || 0);
      setLimitBabyChairsReservation(
        restaurants.limit_baby_chairs_reservation || 0
      );
      setEachTime(restaurants.each_time || "00:15");
      setAutoAcceptLimit(restaurants.auto_accept_limit || "");
      setAcceptPeoplePerEachTime(restaurants.accept_people_per_each_time || "");
      setTimezone(restaurants.timezone || getTimezone());
      setAutoAcceptTimeLimit(
        restaurants.only_auto_accept_before_this_time || ""
      );
      setMessageReminderTime(
        restaurants.send_message_reminder_to_customers || ""
      );
      setAutoSetTables(restaurants.auto_set_tables || null);
      setTimeToCancelledWarning(restaurants.time_to_cancelled_warning || "");
      setPhoneWithoutCountryCode(restaurants.phone_number || "");
      setCountryCodeNumber(restaurants.country_code || "351");
      setRestaurant_description(restaurants.restaurant_description || "");
      setReconfirmation_duration(restaurants.reconfirmation_duration || "");
      setReconfirmation_time_before_date(
        restaurants.reconfirmation_time_before_date || ""
      );
    }
  }, [restaurants]);

  function checkEmptyStates() {
    const invalid = new Set();
    const emptyStates = [];

    if (restaurantName === "") {
      emptyStates.push("Nome do restaurante");
      invalid.add("restaurant_name");
    }
    if (!address) {
      emptyStates.push("Morada");
      invalid.add("adress");
    }
    if (numberOfBabyChairs === "") {
      emptyStates.push("Numero de cadeiras para bebês");
      invalid.add("number_of_babychairs");
    }
    if (!limitPeopleReservation) {
      emptyStates.push("Limite de pessoas por reserva");
      invalid.add("limit_people_reservation");
    }
    if (!limitBabyChairsReservation) {
      emptyStates.push("Limite de cadeiras para bebês por reserva");
      invalid.add("limit_baby_chairs_reservation");
    }
    if (!autoAcceptLimit) {
      emptyStates.push("Aceitação automatica");
      invalid.add("auto_accept_limit");
    }
    if (!eachTime) {
      emptyStates.push("Cada tempo");
      invalid.add("each_time");
    }
    if (!acceptPeoplePerEachTime) {
      emptyStates.push("Limite de pessoas por tempo");
      invalid.add("accept_people_per_each_time");
    }
    if (
      phoneWithoutCountryCode &&
      !isValidNumber("+" + countryCodeNumber + phoneWithoutCountryCode)
    ) {
      emptyStates.push("Telemóvel inválido");
      invalid.add("phone_number");
    }
    if (!postalCode) {
      emptyStates.push("Código Postal");
      invalid.add("postalCode");
    }
    if (!locality) {
      emptyStates.push("Localidade");
      invalid.add("locality");
    }

    setInvalidFields(invalid);

    if (emptyStates.length > 0) {
      return (
        "Os seguintes campos não estão corretamente preenchidos: " +
        emptyStates.join(", ")
      );
    } else {
      return "ok_status";
    }
  }

  function checkForErrorsAndCreateRestaurant() {
    let status_error = checkEmptyStates();
    setErrorMessage(status_error);
    if (status_error === "ok_status") {
      setShowError(false);
      const updatedRestaurantParams = {
        restaurant_name: restaurantName,
        adress: address,
        postal_code: postalCode,
        locality: locality,
        latitude: latitudeField,
        longitude: longitudeField,
        view_distance: viewDistance,
        number_of_chairs: numberOfChairs,
        number_of_babychairs: numberOfBabyChairs,
        limit_people_reservation: limitPeopleReservation,
        limit_baby_chairs_reservation: limitBabyChairsReservation,
        auto_accept_limit: autoAcceptLimit,
        accept_people_per_each_time: acceptPeoplePerEachTime,
        each_time: eachTime,
        timezone: timezone,
        only_auto_accept_before_this_time: autoAcceptTimeLimit,
        send_message_reminder_to_customers: messageReminderTime,
        auto_set_tables: autoSetTables,
        time_to_cancelled_warning: timeToCancelledWarning,
        country_code: countryCodeNumber,
        phone_number: phoneWithoutCountryCode,
        restaurant_description: restaurant_description,
        reconfirmation_duration: reconfirmation_duration,
        reconfirmation_time_before_date: reconfirmation_time_before_date,
      };
      if (creating_restaurant === "no") {
        dispatch(updateRestaurant(restaurantId, updatedRestaurantParams));
        if (steps) {
          setCreateRestaurantToFalse();
          handleNextStep();
        }
      } else {
        dispatch(createRestaurant(updatedRestaurantParams));
        setCreateRestaurantToFalse();
        handleNextStep();
      }
    } else {
      setShowError(true);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    checkForErrorsAndCreateRestaurant();
  };

  useEffect(() => {
    if (restaurantCreated === true) {
      checkForErrorsAndCreateRestaurant();
    }
  }, [restaurantCreated]);

  useEffect(() => {
    setRestaurant_params({
      restaurant_name: restaurantName,
      adress: address,
      postal_code: postalCode,
      latitude: latitudeField,
      longitude: longitudeField,
      view_distance: viewDistance,
      number_of_chairs: numberOfChairs,
      number_of_babychairs: numberOfBabyChairs,
      limit_people_reservation: limitPeopleReservation,
      limit_baby_chairs_reservation: limitBabyChairsReservation,
      accept_people_per_each_time: acceptPeoplePerEachTime,
      each_time: eachTime,
      only_auto_accept_before_this_time: autoAcceptTimeLimit,
      auto_set_tables: autoSetTables,
      time_to_cancelled_warning: timeToCancelledWarning,
      country_code: countryCodeNumber,
      phone_number: phoneWithoutCountryCode,
    });
  }, [
    dispatch,
    restaurantName,
    address,
    numberOfChairs,
    numberOfBabyChairs,
    limitPeopleReservation,
    limitBabyChairsReservation,
    autoAcceptLimit,
    eachTime,
    acceptPeoplePerEachTime,
    autoSetTables,
    timeToCancelledWarning,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "restaurant_name":
        setRestaurantName(value);
        break;
      case "adress":
        setAddress(value);
        break;
      case "postalCode":
        setPostalCode(value);
        break;
      case "locality":
        setLocality(value);
        break;
      case "number_of_chairs":
        setNumberOfChairs(value);
        break;
      case "number_of_babychairs":
        setNumberOfBabyChairs(value);
        break;
      case "limit_people_reservation":
        setLimitPeopleReservation(value);
        break;
      case "limit_baby_chairs_reservation":
        setLimitBabyChairsReservation(value);
        break;
      case "auto_accept_limit":
        setAutoAcceptLimit(value);
        break;
      case "accept_people_per_each_time":
        setAcceptPeoplePerEachTime(value);
        break;
      case "each_time":
        setEachTime(value);
        break;
      default:
        break;
    }
  };

  const handleIntervalTimeChange = (option) => {
    setEachTime(option);
  };

  const handleTimeCancelWarning = (value) => {
    setTimeToCancelledWarning(value);
  };

  const handleAutoAcceptTimeLimit = (value) => {
    setAutoAcceptTimeLimit(value);
  };

  const handleReconfirmation_time_before_date = (value) => {
    setReconfirmation_time_before_date(value);
  };

  const handleReconfirmation = (value) => {
    setReconfirmation_duration(value);
  };

  const handleMessageReminderTime = (value) => {
    setMessageReminderTime(value);
  };

  const MAX_CHARACTER_LIMIT = 10;
  const handleInputPhoneChange = (e) => {
    const inputValue = e.target.value;

    if (inputValue.length <= MAX_CHARACTER_LIMIT) {
      setPhoneWithoutCountryCode(inputValue);
    }
  };

  const handleMarkerDragEnd = React.useCallback((event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setMarker({ lat, lng });
    setLatitudeField(lat);
    setLongitudeField(lng);
    setMapCenter({ lat, lng });
  }, []);

  return (
    <Container>
      <Row>
        <Col sm={12} md={12} xl={12}>
          {error && <Messages variant="error">{restaurants.message}</Messages>}
          <CardHeader>
            <CardHeaderTitle>
              Informações
              <div></div>
            </CardHeaderTitle>
          </CardHeader>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Messages variant="error">{error}</Messages>
          ) : (
            <>
              {/* Only this middle area scrolls; the page itself does not */}
              <PageScroll ref={pageRef} height={pageHeight}>
                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <StyledLabel htmlFor="restaurant_name">
                      Nome do restaurante
                    </StyledLabel>
                    <StyledInput
                      type="text"
                      id="restaurant_name"
                      name="restaurant_name"
                      placeholder="Nome do restaurante"
                      value={restaurantName}
                      onChange={handleChange}
                      invalid={invalidFields.has("restaurant_name")}
                    />
                  </FormGroup>
                  <FormGroup controlId="restaurantDescription">
                    <StyledLabel>Descrição</StyledLabel>
                    <StyledInput
                      as="textarea"
                      rows={4}
                      value={restaurant_description}
                      onChange={(e) =>
                        setRestaurant_description(e.target.value)
                      }
                      placeholder="Escreva uma breve descrição do restaurante que estará visível para os seus clientes."
                    />
                  </FormGroup>

                  <FormGroup>
                    <Row>
                      {/* Left column: Phone + Address + Postal Code + Locality */}
                      <Col xs={12} sm={6} md={6}>
                        {/* Phone */}
                        <FormGroup>
                          <div style={{ position: "relative" }}>
                            <StyledLabel>Telemóvel</StyledLabel>
                            <PhoneField
                              countryCodeNumber={countryCodeNumber}
                              setCountryCodeNumber={setCountryCodeNumber}
                              phoneWithoutCountryCode={phoneWithoutCountryCode}
                              setPhoneWithoutCountryCode={
                                setPhoneWithoutCountryCode
                              }
                              isPhoneValid={isPhoneValid}
                              setIsPhoneValid={setIsPhoneValid}
                              initialFullPhone={`+${countryCodeNumber}${phoneWithoutCountryCode}`}
                            />
                          </div>
                        </FormGroup>

                        {/* Address */}
                        <FormGroup>
                          <StyledLabel htmlFor="adress">Morada</StyledLabel>
                          <StyledInput
                            type="text"
                            id="adress"
                            name="adress"
                            value={address}
                            onChange={handleChange}
                            invalid={invalidFields.has("adress")}
                          />
                        </FormGroup>

                        {/* Postal Code + Locality */}
                        <Row className="mt-3">
                          <Col xs={12} md={6}>
                            <StyledLabel htmlFor="postalCode">
                              Código Postal
                            </StyledLabel>
                            <StyledInput
                              type="text"
                              id="postalCode"
                              name="postalCode"
                              value={postalCode}
                              onChange={handleChange}
                              invalid={invalidFields.has("postalCode")}
                            />
                          </Col>
                          <Col xs={12} md={6}>
                            <StyledLabel htmlFor="locality">
                              Localidade
                            </StyledLabel>
                            <StyledInput
                              type="text"
                              id="locality"
                              name="locality"
                              value={locality}
                              onChange={handleChange}
                              invalid={invalidFields.has("locality")}
                            />
                          </Col>
                        </Row>
                      </Col>

                      {/* Right column: Map */}
                      <Col xs={12} sm={6} md={6} className="mt-4 mt-sm-0">
                        {isGoogleLoaded && marker?.lat && marker?.lng && (
                          <MapContainer>
                            <GoogleMap
                              mapContainerStyle={{
                                width: "100%",
                                height: "100%",
                              }}
                              center={mapCenter}
                              zoom={viewDistance || 18}
                              onClick={onMapClick}
                              onLoad={handleOnLoad}
                              options={{
                                streetViewControl: false,
                                mapTypeControl: false,
                                fullscreenControl: false,
                                zoomControl: true,
                              }}
                            >
                              <Marker
                                position={{
                                  lat: marker.lat,
                                  lng: marker.lng,
                                }}
                                draggable={true}
                                onDragEnd={handleMarkerDragEnd}
                              />
                            </GoogleMap>
                          </MapContainer>
                        )}
                      </Col>
                    </Row>
                  </FormGroup>

                  {steps === false ? (
                    <>
                      {/* {errorMessage !== "ok_status" && (
  <div style={{ color: "red", marginBottom: "10px" }}>
    {errorMessage}
  </div>
)} */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "20px",
                        }}
                      >
                        <ModernButton
                          color="#EE754C"
                          fontSize="14px"
                          type="submit"
                        >
                          Guardar
                        </ModernButton>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </Form>
              </PageScroll>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default RestaurantSettingsUpdate;
